module.exports = __webpack_public_path__ + "static/media/modmemes.bc5524ff.jpg";